import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ResultComponent } from './result/result.component';
import { SearchByLocationComponent } from './search-by-location/search-by-location.component';
import { SearchResultsLocationComponent } from './search-results-location/search-results-location.component';
import { SearchLocationNoResultsComponent } from './search-location-no-results/search-location-no-results.component';
import { FileAnIssueComponent } from './file-an-issue/file-an-issue.component';
import { IssueFiledComponent } from './issue-filed/issue-filed.component';

const routes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'result', component: ResultComponent },
  { path: 'search-by-location', component: SearchByLocationComponent },
  { path: 'search-results-location', component: SearchResultsLocationComponent },
  { path: 'search-location-no-results', component: SearchLocationNoResultsComponent },
  { path: 'file-an-issue', component: FileAnIssueComponent },
  { path: 'issue-filed', component: IssueFiledComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { relativeLinkResolution: 'legacy' })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
